<template>
  <div class="navbar-header">
    <div class="navbar-brand">
      <div class="logo">
        <router-link to="/" exact-active-class="is-active">
          <img src="../assets/image/index-logo.png" />
        </router-link>
      </div>
    </div>
    <!-- 添加汉堡菜单按钮，在小屏幕下显示 -->
    <div class="navbar-burger" :class="{ 'is-active': isMenuActive }" @click="menuToggle">
      <div class="burger-container">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    <div class="navbar-menu" :class="{ 'is-active': isMenuActive }">
      <div class="navbar-start">
  <!-- 超声教育菜单 -->
        <div class="nav-item-wrapper" :class="{'is-active': activeDropdown === 'education'}">
          <!-- 移动端显示 -->
          <div v-if="isMobile" class="nav-item mobile-nav-item" @click="toggleMobileDropdown('education')" style="padding: 15px 10px;">
            <span class="has-text-weight-bold">超声教育</span>
          </div>
          <!-- 移动端下拉内容 -->
          <div class="dropdown-content mobile-dropdown-content" v-if="isMobile && activeDropdown === 'education'">
            <div class="dropdown-section" @click.stop>
              <div class="dropdown-title">初级课程</div>
              <div class="dropdown-links">
                <router-link v-for="item in lowCourseList" :key="item.id" class="dropdown-link" :to="'/course/' + item.id"
                  exact-active-class="is-active" @click.native="closeAllDropdowns">
                  <span>{{ item.cnName }}</span>
                </router-link>
              </div>
            </div>
            <div class="dropdown-section" @click.stop>
              <div class="dropdown-title">高级课程</div>
              <div class="dropdown-links">
                <router-link v-for="item in highCourseList" :key="item.id" class="dropdown-link" :to="'/course/' + item.id"
                  exact-active-class="is-active" @click.native="closeAllDropdowns">
                  <span>{{ item.cnName }}</span>
                </router-link>
              </div>
            </div>
          </div>
          <!-- PC端显示 -->
          <nav-bar-menu v-if="!isMobile" class="navbar-item has-dropdown is-hoverable">
            <span class="has-text-weight-bold">超声教育</span>
            <div class="navbar-dropdown">
              <div class="navbar-item has-dropdown is-hoverable">
                <span>初级课程</span>
                <div class="navbar-dropdown">
                  <router-link v-for="item in lowCourseList" :key="item.id" class="navbar-item" :to="'/course/' + item.id"
                    exact-active-class="is-active">
                    <span>{{ item.cnName }}</span>
                  </router-link>
                </div>
              </div>
              <div class="navbar-item has-dropdown is-hoverable">
                <span>高级课程</span>
                <div class="navbar-dropdown">
                  <router-link v-for="item in highCourseList" :key="item.id" class="navbar-item"
                    :to="'/course/' + item.id" exact-active-class="is-active">
                    <span>{{ item.cnName }}</span>
                  </router-link>
                </div>
              </div>
              <div class="navbar-item is-hoverable">
                <a href="http://www.leesmed.org/col.jsp?id=160" target="_blank" style="color: #333333">
                  <span>中欧超声心动图继续教育项目</span>
                </a>
              </div>
            </div>
          </nav-bar-menu>
        </div>

        <!-- 模拟考试菜单 -->
        <div class="nav-item-wrapper" :class="{'is-active': activeDropdown === 'exam'}">
          <!-- 移动端显示 -->
          <div v-if="isMobile" class="nav-item mobile-nav-item" @click="toggleMobileDropdown('exam')" style="padding: 15px 10px;">
            <span class="has-text-weight-bold">模拟考试</span>
          </div>
          <!-- 移动端下拉内容 -->
          <div class="dropdown-content mobile-dropdown-content" v-if="isMobile && activeDropdown === 'exam'">
            <div class="dropdown-link" v-for="(item, index) in examList" :key="index" @click.stop="handleClickExam(item)">
              <span>{{ item.name }}</span>
            </div>
          </div>
          <!-- PC端显示 -->
          <nav-bar-menu v-if="!isMobile" class="has-divider is-hoverable">
            <span class="has-text-weight-bold">模拟考试</span>
            <div slot="dropdown" class="navbar-dropdown">
              <div class="navbar-item" v-for="(item, index) in examList" :key="index" style="cursor: pointer"
                @click="handleClickExam(item)">
                <span>{{ item.name }}</span>
              </div>
            </div>
          </nav-bar-menu>
        </div>

        <!-- 普通菜单项 -->
        <router-link to="/liveShow" class="nav-item" @click.native="closeAllDropdowns">
          <span class="has-text-weight-bold">直播课堂</span>
        </router-link>
        <router-link to="/cases" class="nav-item" @click.native="closeAllDropdowns">
          <span class="has-text-weight-bold">案例365</span>
        </router-link>
        <router-link to="/albums" class="nav-item" @click.native="closeAllDropdowns">
          <span class="has-text-weight-bold">精彩图库</span>
        </router-link>
        <router-link to="/news" class="nav-item" @click.native="closeAllDropdowns">
          <span class="has-text-weight-bold">学术会议</span>
        </router-link>
        <div @click="goBbs('/')" class="nav-item">
          <span class="has-text-weight-bold" style="cursor: pointer">超声社区</span>
        </div>
        <router-link to="/about" class="nav-item" @click.native="closeAllDropdowns">
          <span class="has-text-weight-bold">关于我们</span>
        </router-link>

        <!-- 用户菜单 -->
        <div class="navbar-end">
          <div v-if="username === null" class="nav-item login-item">
            <login-layer @loginSuccess="loginOk" />
          </div>
          <div v-else class="nav-item-wrapper user-wrapper" :class="{'is-active': activeDropdown === 'user'}">
            <!-- 移动端和PC端共用的用户信息显示 -->
<!--            <div class="user-info" @click="isMobile ? toggleMobileDropdown('user') : null">-->
<!--              <user-avatar />-->
<!--              <div class="is-user-name">-->
<!--                <span>{{ username }}</span>-->
<!--              </div>-->
<!--            </div>-->
            <!-- 移动端下拉内容 -->
            <div class="dropdown-content" v-if="isMobile && activeDropdown === 'user'">
              <a class="dropdown-link" :href="profileUrl" target="_blank" @click="closeAllDropdowns">
                <span>编辑资料</span>
              </a>
              <router-link to="/my-course" class="dropdown-link" exact-active-class="is-active" @click.native="closeAllDropdowns">
                <span>学习进度</span>
              </router-link>
              <router-link to="/member" class="dropdown-link" exact-active-class="is-active" @click.native="closeAllDropdowns">
                <span>会员</span>
              </router-link>
              <div class="dropdown-link" @click="logout">
                <span>退出登录</span>
              </div>
            </div>
            <!-- PC端显示 -->
            <nav-bar-menu v-if="!isMobile" class="has-divider has-user-avatar">
              <user-avatar />
              <div class="is-user-name">
                <span>{{ username }}</span>
              </div>
              <div slot="dropdown" class="navbar-dropdown">
                <a class="navbar-item" :href="profileUrl" target="_blank">
                  <b-icon icon="account" custom-size="default" />
                  <span>编辑资料</span>
                </a>
                <router-link to="/my-course" class="navbar-item" exact-active-class="is-active">
                  <b-icon icon="account" custom-size="default" />
                  <span>学习进度</span>
                </router-link>
                <router-link to="/member" class="navbar-item" exact-active-class="is-active">
                  <b-icon icon="email" custom-size="default" />
                  <span>会员</span>
                </router-link>
                <hr class="navbar-divider" />
                <a class="navbar-item">
                  <b-button type="is-ghost" icon-left="logout" @click="logout">退出登录</b-button>
                </a>
              </div>
            </nav-bar-menu>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { mapState } from "vuex";
import NavBarMenu from "@/components/NavBarMenu.vue";
import UserAvatar from "@/components/UserAvatar.vue";
import LoginLayer from "@/components/LoginLayer.vue";
import { getCourseList, getExamList } from "@/api/bus-course";
import { getUserName } from "@/utils/auth";

export default defineComponent({
  name: "NavBar",
  components: {
    UserAvatar,
    NavBarMenu,
    LoginLayer,
  },
  data() {
    return {
      profileUrl: process.env.VUE_APP_BBS_URL + "/user/profile",
      isComponentModalActive: false,
      isMenuActive: false,
      lowCourseList: [],
      highCourseList: [],
      otherCourseList: [],
      total: 0,
      loading: true,
      examList: [],
      windowWidth: window.innerWidth,
      activeDropdown: null
    };
  },
  computed: {
    asideMobileIcon() {
      return this.isAsideMobileExpanded ? "backburger" : "forwardburger";
    },
    menuToggleIcon() {
      return this.isMenuActive ? "close" : "dots-vertical";
    },
    isMobile() {
      return this.windowWidth <= 1024;
    },
    ...mapState([
      "isAsideMobileExpanded",
      "isNavBarVisible",
      "numbUserName",
      "username",
    ]),
  },
  mounted() {
    this.curUserName = getUserName();
    this.$router.afterEach(() => {
      this.isMenuActive = false;
      this.closeAllDropdowns();
    });

    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);
    // 监听点击事件，点击外部时关闭下拉菜单
    document.addEventListener('click', this.handleOutsideClick);
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener('click', this.handleOutsideClick);
  },
  created() {
    this.getList();
    this.getExamList();
    console.log("BBS URL:", process.env.VUE_APP_BBS_URL);
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
      if (this.windowWidth > 1024) {
        this.closeAllDropdowns();
      }
    },
    handleOutsideClick(event) {
      const dropdown = event.target.closest('.nav-item-wrapper');
      if (!dropdown && this.activeDropdown) {
        this.closeAllDropdowns();
      }
    },
    toggleMobileDropdown(name) {
      if (this.isMobile) {
        this.activeDropdown = this.activeDropdown === name ? null : name;
      }
    },
    closeAllDropdowns() {
      this.activeDropdown = null;
    },
    loginOk() {
      console.log("loginOk");
      this.curUserName = getUserName();
    },
    getList() {
      this.loading = true;
      getCourseList().then((response) => {
        this.lowCourseList = response.data.list.filter(el => el.level.includes('初级'));
        this.highCourseList = response.data.list.filter(el => el.level.includes('高级'));
        this.otherCourseList = response.data.list.filter(el => el.level.includes('其它'));
        this.total = response.data.count;
        this.loading = false;
        this.$store.commit('custom/setCourseList', response.data.list)
      });
    },
    getExamList() {
      getExamList({
        pageIndex: 1,
        pageSize: 999
      }).then(res => {
        this.examList = res.data.list || [];
      })
    },
    asideToggleMobile() {
      this.$store.commit("asideMobileStateToggle");
    },
    asideDesktopOnlyToggle() {
      this.$store.dispatch("asideDesktopOnlyToggle");
    },
    menuToggle() {
      this.isMenuActive = !this.isMenuActive;
      if (!this.isMenuActive) {
        this.closeAllDropdowns();
      }
    },
    logout() {
      this.$buefy.dialog.confirm({
        message: "确定登出吗?",
        onConfirm: () => {
          this.$store.dispatch("LogOut").then(() => {
            location.reload();
          });
          this.$buefy.toast.open("User confirmed");
        },
      });
      this.$buefy.snackbar.open({
        message: "Log out clicked",
        queue: false,
      });
    },
    goBbs() {
      location.href = process.env.VUE_APP_BBS_URL
    },
    handleClickExam(item) {
      if (!this.$store.state.token) {
        sessionStorage.setItem('attemptedURL', `/user-exam/` + item.id)
        this.$store.dispatch("LogOut");
        return;
      }
      let id = item.id
      if (item.courseGoods && item.courseGoods.id) {
        id = item.courseGoods.id
      }
      this.$router.push(`/user-exam/` +  id)
      this.closeAllDropdowns();
    }
  },
});
</script>

<style scoped lang="scss">
/* 基本样式 */
.navbar-header {
  background-color: #fff;
  width: 100%;
  max-width: 1920px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 1000;
  padding: 14px 200px;
  box-sizing: border-box;
  //box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Logo样式 */
.logo {
  //width: 250px;
  height: 72px;
  img {
   // width: 100%;
   height: 100%;
  }
}

/* 导航菜单样式 */
.navbar-menu {
  display: flex;
  flex: 1;
}

.navbar-start {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  width: 100%;
  gap: 0.5rem;
  justify-content: flex-end;
}

.navbar-end {
  margin-left: 1rem;
  display: flex;
  align-items: center;
}

.login-item, .user-wrapper {
  margin-left: 0.5rem;
}

/* 导航项统一样式 */
.nav-item, .navbar-item {
  font-size: 18px !important;
  font-weight: 500 !important;
  font-family: "Lucida Sans", "Lucida Sans Regular", "Lucida Grande",
    "Lucida Sans Unicode", Geneva, Verdana, sans-serif;
  color: #333 !important;
  padding: 0.5rem 0.5rem;
  white-space: nowrap;
  text-align: center;
  cursor: pointer;
  &.is-active {
    color: #fff !important;
    background-color: #57AECC !important;
  }
}

/* 下拉箭头样式 */
.dropdown-arrow {
  font-size: 12px;
  margin-left: 4px;
  display: inline-block;
  vertical-align: middle;
  color: inherit;
}

/* 导航项包装器 */
  .nav-item-wrapper {
    position: relative;
    display: flex;
    align-items: center;
  }

  @media (max-width: 1024px) {
    .nav-item-wrapper {
      flex-direction: column;
      align-items: flex-start;
      width: 100%;
      margin-bottom: 0;
      padding: 0;
    }
  }

/* 确保nav-item-wrapper内的nav-item没有额外padding */
.nav-item-wrapper .nav-item {
  padding: 0;
}

/* 确保PC端下拉菜单的间距一致 */
.nav-item-wrapper .navbar-item {
  padding: 0;
}

/* 下拉内容统一样式 */
.dropdown-content {
  display: block;
  background-color: #fff;
  padding: 10px 0;
  margin-top: 5px;
  border-radius: 4px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  width: 100%;
  position: absolute;
  z-index: 10;
}

/* 移动端下的二级菜单背景色 */
.dropdown-section .dropdown-links {
  background-color: #F0F7FF;
}

  .dropdown-section {
    margin-bottom: 10px;
  }

  .dropdown-title {
    font-weight: bold;
    display: block;
    padding: 5px 15px;
    border-bottom: 1px solid #eee;
    background-color: #fff;
  }

  .dropdown-links {
    padding-left: 15px;
    margin-top: 5px;
  }

  .dropdown-link {
    display: block;
    padding: 12px 15px;
    color: #333;
    text-decoration: none;
    border-radius: 4px;

    &:hover {
      color: #57AECC;
      background-color: #E5E5E5;
    }

    &.is-active {
      color: #fff;
      background-color: #57AECC;
    }
  }

  @media (max-width: 1024px) {
    .dropdown-section {
      margin-bottom: 0;
    }

    .dropdown-title {
      padding: 10px 15px;
      background-color: #fff;
    }

    /* 移动端下的二级菜单标题 */
    .dropdown-section .dropdown-title {
      background-color: #F0F7FF;
    }

    .dropdown-links {
      padding-left: 0;
    }

    .dropdown-link {
      padding: 12px 20px;
      border-bottom: 1px solid #f0f0f0;

      &:last-child {
        border-bottom: none;
      }
    }
  }

/* 确保下拉菜单中的项目左对齐 */
.navbar-dropdown .navbar-item {
  text-align: left;
  padding: 0.375rem 0.75rem;
  border-radius: 0;
}

/* 确保二级菜单项有足够的宽度 */
.navbar-dropdown > .navbar-item {
  min-width: 120px;
}

/* 下拉菜单样式 */
.navbar-dropdown {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 8px 8px rgba(10, 10, 10, 0.1);
}

/* 三级菜单（具体课程）的背景色 */
.navbar-dropdown .navbar-dropdown {
  background-color: #F0F7FF;
  border-radius: 0;
  box-shadow: none;
  border: 1px solid #e8e8e8;
}

/* 三级菜单项样式 */
.navbar-dropdown .navbar-dropdown .navbar-item {
  padding: 10px 15px;
}

/* 选中的菜单项样式 */
.navbar-dropdown .navbar-item.is-active {
  background-color: #57AECC;
  color: #fff !important;
}

.navbar-item.is-hoverable:hover .navbar-dropdown .navbar-dropdown {
  display: none;
}

.navbar-dropdown .navbar-item.is-hoverable:hover > .navbar-dropdown {
  display: block;
}

.navbar-dropdown .navbar-item .navbar-dropdown {
  top: -10px;
  margin-left: 100%;
  box-shadow: 0 16px 8px -8px rgba(10, 10, 10, 0.1),
    8px 0 8px -8px rgba(10, 10, 10, 0.1);
}
.navbar-item.has-dropdown .navbar-dropdown .navbar-item {
  span {
    color: #333333;
  }

  &:hover {
    background: #E5E5E5;

    > span {
      color: #57AECC;
    }
  }
}
.navbar-dropdown .navbar-item.has-dropdown {
  span{
    color: #333333;
  }
  &:hover{
    background: #E5E5E5;
    >span {
      color: #57AECC;
    }
    .navbar-dropdown{
      background: #F0F7FF;
      .navbar-item:hover {
        background: #57AECC;
        span{
          color: #ffffff;
        }
      }
    }
  }
}

.navbar-dropdown .navbar-item.has-dropdown > .navbar-link {
  width: 100%;
  padding: 0.375rem 1rem;
  background-color: #fff;
}

.navbar-dropdown .navbar-item.has-dropdown > .navbar-link:not(.is-arrowless) {
  padding-right: 2.5em;
}

/* 用户信息样式 */
.user-info {
  display: flex;
  align-items: center;
  cursor: pointer;
}

/* 汉堡菜单按钮样式 */
.navbar-burger {
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  margin-left: auto;
  z-index: 100;
  position: absolute;
  right: 20px;
  top: 25px;
  width: 44px;
  height: 44px;
  border-radius: 4px;
}

.burger-container {
  width: 100%;
  height: 100%;
  background-color: #fff;
  flex-direction: column;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3px;
}

.navbar-burger span {
  display: block;
  width: 28px;
  height: 3px;
  background-color: #333;
  transition: all 0.3s ease;
  border-radius: 2px;
  position: relative;
  left: initial !important;
  top: initial !important;
}

.navbar-burger.is-active span:nth-child(1) {
  transform: translateY(6px) rotate(45deg);
}

.navbar-burger.is-active span:nth-child(2) {
  opacity: 0;
}

.navbar-burger.is-active span:nth-child(3) {
  transform: translateY(-6px) rotate(-45deg);
}

/* 其他样式 */
.span-title {
  font-family: "Heiti SC", "SimHei", sans-serif;
  color: #000;
}

/* 响应式布局 */
@media (max-width: 1700px) {
  .navbar-header {
    padding: 14px 80px;
  }
}

@media (max-width: 1400px) {
  .navbar-header {
    padding: 14px 50px;
  }
}

@media (max-width: 1200px) {
  .navbar-header {
    padding: 14px 30px;
  }

  .nav-item, .navbar-item {
    font-size: 16px !important;
    padding: 0.5rem 0.5rem;
  }
}

/* 小屏幕适配 */
@media (max-width: 1024px) {
  .navbar-header {
    padding: 10px 20px;
    flex-direction: column;
    align-items: flex-start;
    min-width: auto;
    width: 100%;
  }

  .navbar-brand {
    width: 100%;
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
  }

  .logo {
    width: 200px;
   // height: 58px;
  }

  .navbar-burger {
    display: block !important;
  }

  .navbar-menu {
    display: none;
    width: 100%;
    padding: 20px;
    margin-top: 10px;
    border-top: 1px solid #f5f5f5;
  }

  .navbar-menu.is-active {
    display: block !important;
  }

  .navbar-start {
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }

  .nav-item, .navbar-item {
    width: 100%;
    padding: 15px 10px;
    margin-bottom: 0;
    text-align: left;
    border-bottom: 1px solid #f5f5f5;
  }

  /* 确保带有下拉图标的菜单项布局正确 */
  .mobile-nav-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  /* 移除这个重复的样式，使用通用的nav-item样式 */

  .dropdown-icon {
    font-size: 12px;
    margin-left: 5px;
    transition: transform 0.3s ease;
  }

  .is-active .dropdown-icon {
    transform: rotate(180deg);
  }

  .navbar-end {
    margin-left: 0;
    width: 100%;
    padding-top: 10px;
    border-top: 1px solid #f5f5f5;
  }

  .dropdown-content {
    position: relative;
    margin-top: 10px;
    margin-bottom: 10px;
    border-top: 1px solid #f5f5f5;
    border-bottom: 1px solid #f5f5f5;
  }

  .mobile-dropdown-content {
    width: 100%;
    box-shadow: none;
    padding: 0;
    margin: 0;
    border-bottom: 1px solid #f5f5f5;
  }

  .nav-item-wrapper.is-active .mobile-nav-item {
    border-bottom: none;
  }

  .login-item, .user-wrapper {
    margin-left: 0;
  }
}
</style>
